export default __webpack_public_path__ + "static/media/instalacion-llave-en-mano.ec64ba27.png";